import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/productgrid.css';

const ProductGrid = ({ 
  products, 
  layout = 'grid-4',
  maxItems,
  showViewMore = true,
  sectionTitle = '',
  onViewMore
}) => {
  const navigate = useNavigate();
  const [displayCount, setDisplayCount] = React.useState(maxItems || products.length);

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const displayedProducts = products.slice(0, displayCount);

  const handleViewMoreClick = () => {
    if (onViewMore) {
      onViewMore();
    } else {
      setDisplayCount(prev => prev + (layout === 'grid-4' ? 4 : 3));
    }
  };

  return (
    <div className="product-section">
      {sectionTitle && (
        <div className="section-header">
          <h2>{sectionTitle}</h2>
          <div className="orange-underline"></div>
        </div>
      )}
      
      <div className={`product-grid ${layout}`}>
        {displayedProducts.map((product) => (
          <div 
            key={product.id} 
            className="product-card"
            onClick={() => handleProductClick(product.id)}
            role="button"
            tabIndex={0}
          >
            <div className="product-image">
              <img src={product.image} alt={product.name} />
            </div>
            <h3 className="product-title">{product.name}</h3>
            <button 
              className="view-product-btn"
              onClick={(e) => {
                e.stopPropagation(); // Prevent double navigation
                handleProductClick(product.id);
              }}
            >
              View Product
            </button>
          </div>
        ))}
      </div>
      
      {showViewMore && (
        <div className="view-more">
          <button 
            className="view-more-btn"
            onClick={handleViewMoreClick}
          >
            View More
            <span className="arrow-icon">→</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;